import {ajax} from "utils/ajax.js"

export const SquareOfSolidarityApi =  async (id) =>{
      const response= await ajax(null, `Warehouse/Catgories/${id}/Subjects`, 'POST', true)
    if(response?.data?.success===true){
               return response?.data
          }
}
export const SquareDashboardApi =  async (id) =>{
      const response= await ajax(null, `Warehouse/Dashboard/${id}`, 'POST', true)
    if(response?.data?.success===true){
               return response?.data
          }
}
